import { Box, styled } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

import { EDropdownPlacement } from '#entities';

import { NavigationMenu } from '../../NavigationMenu';

const PREFIX = 'TSMED-LayoutPage';
export const layoutPageClasses = {
  root: `${PREFIX}-root`,
};

const Root = styled(Box, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'var(--vh-full)',
  minHeight: 0,
  padding: spacing(0, 0),
}));

export const Layout = ({ children }: PropsWithChildren) => {
  const location = useLocation();

  return (
    <Root id="layout">
      <NavigationMenu
        value={location.pathname}
        placement={EDropdownPlacement.Fixed}
      />
      {children}
    </Root>
  );
};
